/* Death Rise — behaviour for the dr-* sections.
   No dependencies. Everything is delegated or scoped to a section root so the
   theme editor can add/remove sections without re-running a global init. */

(function () {
  'use strict';

  /* ----------------------------------------------------------------------
     Tabbed panels (product rails, goal grid gender toggle)
     Markup contract:
       [data-dr-tabs]
         button.dr-tab[role=tab][aria-controls=PANEL_ID][aria-selected]
         [role=tabpanel]#PANEL_ID[hidden]
     ---------------------------------------------------------------------- */

  function selectTab(group, tab) {
    var tabs = group.querySelectorAll('[role="tab"]');
    for (var i = 0; i < tabs.length; i++) {
      var isTarget = tabs[i] === tab;
      tabs[i].setAttribute('aria-selected', isTarget ? 'true' : 'false');
      tabs[i].tabIndex = isTarget ? 0 : -1;

      var panel = group.querySelector('#' + CSS.escape(tabs[i].getAttribute('aria-controls')));
      if (panel) panel.hidden = !isTarget;
    }
  }

  function initTabs(root) {
    var groups = root.querySelectorAll('[data-dr-tabs]');

    groups.forEach(function (group) {
      if (group.dataset.drTabsReady) return;
      group.dataset.drTabsReady = '1';

      var tabs = Array.prototype.slice.call(group.querySelectorAll('[role="tab"]'));

      group.addEventListener('click', function (event) {
        var tab = event.target.closest('[role="tab"]');
        if (tab && group.contains(tab)) selectTab(group, tab);
      });

      // Left/right arrows move between tabs, per the WAI-ARIA tabs pattern.
      group.addEventListener('keydown', function (event) {
        if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
        var current = document.activeElement.closest('[role="tab"]');
        if (!current) return;

        var index = tabs.indexOf(current);
        var next = tabs[(index + (event.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length];
        next.focus();
        selectTab(group, next);
        event.preventDefault();
      });
    });
  }

  /* ----------------------------------------------------------------------
     Drop countdown
     [data-dr-countdown="2026-09-01T10:00:00Z"] with .dr-count__num[data-unit]
     ---------------------------------------------------------------------- */

  function pad(n) { return n < 10 ? '0' + n : String(n); }

  function initCountdowns(root) {
    var timers = root.querySelectorAll('[data-dr-countdown]');

    timers.forEach(function (timer) {
      if (timer.dataset.drCountReady) return;
      timer.dataset.drCountReady = '1';

      var target = Date.parse(timer.getAttribute('data-dr-countdown'));
      if (isNaN(target)) { timer.setAttribute('data-expired', 'true'); return; }

      var cells = {};
      timer.querySelectorAll('[data-unit]').forEach(function (el) {
        cells[el.getAttribute('data-unit')] = el;
      });
      var live = timer.querySelector('[data-dr-count-live]');

      function tick() {
        var left = target - Date.now();

        if (left <= 0) {
          timer.setAttribute('data-expired', 'true');
          if (live) live.textContent = timer.getAttribute('data-expired-text') || 'This drop is live now.';
          clearInterval(handle);
          return;
        }

        var secs = Math.floor(left / 1000);
        var parts = {
          days: Math.floor(secs / 86400),
          hours: Math.floor(secs / 3600) % 24,
          mins: Math.floor(secs / 60) % 60,
          secs: secs % 60
        };

        for (var unit in parts) {
          if (cells[unit]) cells[unit].textContent = pad(parts[unit]);
        }

        // Screen readers get a coarse figure, updated once a minute, instead of
        // a per-second stream of noise.
        if (live && parts.secs === 0) {
          live.textContent = parts.days + ' days, ' + parts.hours + ' hours, ' +
            parts.mins + ' minutes until this drop.';
        }
      }

      tick();
      var handle = setInterval(tick, 1000);
    });
  }

  /* ----------------------------------------------------------------------
     Rail arrows — scroll the open panel's rail by roughly one viewport.
     The arrows live in the section header and the rails live in tab panels,
     so the target is resolved at click time from whichever panel is open.
     ---------------------------------------------------------------------- */

  function initRails(root) {
    root.querySelectorAll('[data-dr-rail-next], [data-dr-rail-prev]').forEach(function (button) {
      if (button.dataset.drRailReady) return;
      button.dataset.drRailReady = '1';

      button.addEventListener('click', function () {
        var section = button.closest('[data-dr-tabs]') || button.closest('section');
        if (!section) return;

        var rail = section.querySelector('.dr-panel:not([hidden]) .dr-rail') ||
                   section.querySelector('.dr-rail');
        if (!rail) return;

        var dir = button.hasAttribute('data-dr-rail-next') ? 1 : -1;
        rail.scrollBy({ left: dir * rail.clientWidth * 0.9, behavior: 'smooth' });
      });
    });
  }

  /* ----------------------------------------------------------------------
     Marquee pause. Hover and focus pause it in CSS; this is the explicit
     control, which is the only one that works on touch.
     ---------------------------------------------------------------------- */

  function initMarquees(root) {
    root.querySelectorAll('.dr-marquee__pause').forEach(function (button) {
      if (button.dataset.drPauseReady) return;
      button.dataset.drPauseReady = '1';

      var marquee = button.closest('.dr-marquee');
      if (!marquee) return;

      button.addEventListener('click', function () {
        var paused = marquee.getAttribute('data-paused') === 'true';
        marquee.setAttribute('data-paused', paused ? 'false' : 'true');
        button.setAttribute('aria-pressed', paused ? 'false' : 'true');
        button.setAttribute('aria-label', paused
          ? button.getAttribute('data-label-pause')
          : button.getAttribute('data-label-play'));
      });
    });
  }

  function init(root) {
    initTabs(root);
    initCountdowns(root);
    initRails(root);
    initMarquees(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  // Theme editor re-renders one section at a time — re-init just that subtree.
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
